import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { Router } from '@angular/router';
import { AuthService } from '@fuse/services/auth/auth.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class LoginComponent implements OnInit, OnDestroy {
    loginForm: FormGroup;
    serverBadLogin: boolean;
    private _unsubscribeAll: Subject<any>;
    lang = 'sr';
    badLoginMsg = '';
    hide = true;

    get emailInput(): any { return this.loginForm.get('email'); }
    get passwordInput(): any { return this.loginForm.get('password'); }

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private _router: Router,
        private _authService: AuthService,
        private _translate: TranslateService,
        private _translationLoader: FuseTranslationLoaderService
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            theme: {
                layout: {
                    navbar: {
                        hidden: true
                    },
                    toolbar: {
                        hidden: true
                    },
                    footer: {
                        hidden: true
                    },
                    sidepanel: {
                        hidden: true
                    }
                }
            }
        };

        if (document.getElementById('social-intents-tab-chat') !== null) {
            document.getElementById('social-intents-tab-chat').remove();
        }
        if (document.getElementById('siWidget-chat') !== null) {
            document.getElementById('siWidget-chat').remove();
        }
        if (document.getElementById('sibutton') !== null) {
            document.getElementById('sibutton').remove();
        }
        if (document.getElementById('socialintents-chat') !== null) {
            document.getElementById('socialintents-chat').remove();
        }
        if (document.getElementById('chat') !== null) {
            document.getElementById('chat').remove();
        }

        this._unsubscribeAll = new Subject();
    }

    private getTranslations(): void {
        this._translationLoader.getLastLang()
            .then(response => {
                this.lang = response['code'];
                this._translationLoader.getTranslations(this.lang, '5');
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
    }

    signInWithGoogle(): void {

        this.serverBadLogin = false;
        this._authService.authenticationError = '';
        this._authService.authenticateSocial('google');
    }

    signInWithFB(): void {
        this.serverBadLogin = false;
        this._authService.authenticationError = '';
        this._authService.authenticateSocial('facebook');
    }

    onSubmit(): void {
        this.serverBadLogin = false;
        this._authService.authenticationError = '';
        this._authService.authenticate(this.loginForm.value.emailaksljf, this.loginForm.value.passwordlkjkl);
        // this._authService.authenticationComplete
        //     .pipe(takeUntil(this._unsubscribeAll))
        //     .subscribe(data => {
        //         console.log(data);
        //         if (data) {
        //             this._fuseConfigService.config = {
        //                 fuse: {
        //                     layout: {
        //                         navbar: {
        //                             hidden: false
        //                         },
        //                         toolbar: {
        //                             hidden: false
        //                         }
        //                     }
        //                 }
        //             };
        //             this._router.navigate(['/users-management']);
        //         } else {
        //             this.serverBadLogin = true;
        //         }
        //     });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {

        if (this._authService.isAuthenticated()) {
            this._authService.logout();
        }
        this.loginForm = this._formBuilder.group({
            emailaksljf: ['', [Validators.required, Validators.email]],
            passwordlkjkl: ['', Validators.required]
        });

        this._authService.authenticationComplete
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(data => {
                console.log(data);
                if (data === true) {
                    this._authService.updatePreferredLanguage(this.lang);
                    this._router.navigate(['/welcome']);
                } else {
                    this.serverBadLogin = true;
                    this._authService.errorCode === 503 ? this.badLoginMsg = 'Temporary Rejected!' : this.badLoginMsg = 'Invalid account!';
                    console.log(this._authService.errorCode);
                }

            });
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.getTranslations();
            });

        this.getTranslations();

    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
